"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HopperColumnFullWidthProps = exports.HopperColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.HopperColumnProps = [
    {
        show: true,
        field: 'hopper',
        title: 'Line',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'target_queue_time_display',
        title: 'Target Queue Time',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'target_lead_time_display',
        title: 'Target Lead Time',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'hopper_type',
        title: 'Hopper Type',
        width: '150px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.HopperColumnFullWidthProps = [
    ...exports.HopperColumnProps
];
exports.HopperColumnFullWidthProps[0] = {
    show: true,
    field: 'hopper',
    title: 'Line',
    width: 'auto',
    filter: 'text'
};
exports.HopperColumnFullWidthProps[1] = {
    show: true,
    field: 'target_queue_time_display',
    title: 'Target Queue Time',
    width: '200',
    filter: 'text'
};
exports.HopperColumnFullWidthProps[2] = {
    show: true,
    field: 'target_lead_time_display',
    title: 'Target Lead Time',
    width: '200',
    filter: 'text'
};
exports.HopperColumnFullWidthProps[3] = {
    show: true,
    field: 'hopper_type',
    title: 'Hopper Type',
    width: '150',
    filter: 'text'
};
